export default __webpack_public_path__ + "static/media/fernseh.68651d4c.svg";